import axios from 'axios';
import { TABLEBOOKINGURL } from '../index';

export const getMainTableBookingApi = (postData) => {
  return axios.post(TABLEBOOKINGURL, JSON.stringify(postData));
};

